<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <RuleConfig slot-scope="{data}" :form-data="data" :status-prop="$route.query.status" :type-prop="$route.query.type"></RuleConfig>
  </l-cache>
</template>
<script>
import RuleConfig from './ruleConfig'
export default {
  name: 'ruleConfigBox',
  components: {RuleConfig},
  methods: {
    async getItem (key) {
      if (this.$route.query.status === 'new') {
        return {}
      }
      if (this.$route.query.type === 'simple') {
        let {items} = await this.$store.dispatch('charging/getRuleConfigList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.$route.query.id}})
        return items[0]
      }
      else if (this.$route.query.type === 'period') {
        let {items} = await this.$store.dispatch('charging/getPeriodConfigList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.$route.query.id}})
        return items[0]
      }
    }
  }
}
</script>
